export default "__VITE_ASSET__CrBQwCiS__";